export const normalizeDimensions = (width, height) => {
  let normalizedWidth, normalizedHeight;

  if (width > height) {
    normalizedWidth = width / height;
    normalizedHeight = 1;
  } else {
    normalizedHeight = height / width;
    normalizedWidth = 1;
  }

  return {
    width: normalizedWidth,
    height: normalizedHeight,
  };
};
